const PERMISSION_KEY= "crm:dashboard";
const PERMISSION_CORE_KEY= "crm:dashboard_core";
const PAGE_URL = {
    DASHBOARD_PAGE: "/admin/dashboard"
}

export {PERMISSION_KEY, PERMISSION_CORE_KEY, PAGE_URL}

